/**
 * Replaces the organization slug in a URL pathname with a new organization slug.
 *
 * @param pathname - The current pathname (e.g., "/org/old-slug/dashboard/settings")
 * @param newOrganizationSlug - The new organization slug to replace with
 * @returns The pathname with the organization slug replaced
 *
 * @example
 * replaceOrganizationSlug("/org/old-slug/dashboard/settings", "new-slug")
 * // Returns: "/org/new-slug/dashboard/settings"
 *
 * @example
 * replaceOrganizationSlug("/org/company-a/learn/courses", "company-b")
 * // Returns: "/org/company-b/learn/courses"
 */
export function replaceOrganizationSlug(
  pathname: string,
  newOrganizationSlug: string,
): string {
  if (!pathname || !newOrganizationSlug) {
    return pathname;
  }

  // Use a more robust regex to match the organization slug pattern
  // This pattern matches: /org/[any-slug]/rest-of-path
  const orgSlugRegex = /^\/org\/[^/]+(\/.*)?$/;

  if (!orgSlugRegex.test(pathname)) {
    // If the pathname doesn't match the expected pattern, return as is
    return pathname;
  }

  // Replace the organization slug while preserving the rest of the path
  return pathname.replace(/^\/org\/[^/]+/, `/org/${newOrganizationSlug}`);
}

export default replaceOrganizationSlug;
